import { add, startOfDay } from 'date-fns'

export type BookingSlotResourceLike = {
  timeslot: number
  minTimeSlotsPerBooking: number
  maxTimeSlotsPerBooking: number | null
}

export const isDailyBookingTimeslotResource = (resource: {
  isDailyTimeslot?: boolean | null
  timeslot?: number | null
}): boolean => {
  if (resource.isDailyTimeslot) return true
  const ts = resource.timeslot
  return Number.isFinite(ts as number) && (ts as number) === 1440
}

export const dailyBookingApiStart = (fromDate: Date) => startOfDay(fromDate)

export const dailyBookingExclusiveApiEnd = (toDate: Date) =>
  add(startOfDay(toDate), { days: 1 })

export const bookingSlotMaxSlots = (
  value: number | null | undefined
): number | null => {
  if (value === null || value === undefined) return null
  if (!Number.isFinite(value) || value <= 0) return null
  return value
}

/** Bezpieczne minuty slotu + min/max liczby slotów z danych zasobu (timeline / resolved). */
export const bookingSlotResourceCalculation = (
  resource: BookingSlotResourceLike
) => {
  const timeslotMinutes =
    Number.isFinite(resource.timeslot) && resource.timeslot > 0
      ? resource.timeslot
      : 15

  const minSlots =
    Number.isFinite(resource.minTimeSlotsPerBooking) &&
    resource.minTimeSlotsPerBooking > 0
      ? resource.minTimeSlotsPerBooking
      : 1

  const maxSlots = bookingSlotMaxSlots(resource.maxTimeSlotsPerBooking)

  return { timeslotMinutes, minSlots, maxSlots }
}
